import type { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

import { Link, Typography } from "@aviary";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./PractitionerSignUp.styles";

const EmersonEcologicsMessage: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography>
        {t(l.practitionerSignUp.ComingEmersonEcologics.complementEmersonEcologics)}
      </Typography>
      <Typography>
        <strong css={styles.textBold}>
          {t(l.practitionerSignUp.ComingEmersonEcologics.allAccountsZeroPerMonth)}
        </strong>
      </Typography>
      <Typography>
        <Trans i18nKey={l.practitionerSignUp.ComingEmersonEcologics.lookingForwardToServingYou}>
          We're looking forward to serving you and your patients. Have questions? Our world-class
          customer support team is here to help.
          <Link href="https://calendly.com/fullscript-onboarding/setup-ts" noExternalIcon>
            Book a demo
          </Link>
        </Trans>
      </Typography>
    </>
  );
};

export { EmersonEcologicsMessage };
